module.exports = (function () {
  'use strict';

  function PhxSvgIconController() {
    this.getSVGPath = (iconName) => `./icons.svg#${iconName}`;
  }

  angular.module('ui-ng-svg-icons').controller('PhxSvgIconController', PhxSvgIconController);
})();



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-svg-icons/src/core/svg_controller.es.js